import * as Styles from './styles';
import { ReaderStatusProps } from './types';
import { READER_TONE_COLOR } from './helpers';

// A Clover reader's status: a dot and the server's word ("Ready", "In a
// sale", "Offline", ...). The word and tone come from Main (plan §1); this
// only lays them out.
export const ReaderStatus = ({
  note,
  label,
  reader,
  nameOnly,
  dotAfter,
  className,
  shortLabel,
  testId = 'reader-status',
}: ReaderStatusProps) => {
  const dot = (
    <Styles.Dot
      aria-hidden
      data-tone={reader.tone}
      data-testid={`${testId}-dot`}
      $color={READER_TONE_COLOR[reader.tone] ?? READER_TONE_COLOR.muted}
    />
  );
  const full = label ? `${label} · ${reader.word}` : reader.word;
  // "<name> · <word>": a long name shortens with "…"; the word never does.
  const text =
    nameOnly ??
    (label ? (
      <Styles.Labelled>
        <Styles.Text data-reader-name>{shortLabel || label}</Styles.Text>
        <Styles.Word>{`\u00a0· ${reader.word}`}</Styles.Word>
      </Styles.Labelled>
    ) : (
      full
    ));

  return (
    <Styles.Container
      data-testid={testId}
      className={className}
      data-tone={reader.tone}
      title={nameOnly ? `${nameOnly} · ${reader.word}` : full}
    >
      {!dotAfter && dot}
      {typeof text === 'string' ? <Styles.Text>{text}</Styles.Text> : text}
      {dotAfter && dot}
      {note && <Styles.Note data-testid={`${testId}-word`}>{note}</Styles.Note>}
    </Styles.Container>
  );
};

export {
  asStale,
  findReader,
  lastSeenText,
  isHeldByOther,
  READER_TONE_COLOR,
  RECONNECTING_WORD,
} from './helpers';
export type { ReaderStatusProps };
